import { Box } from "@chakra-ui/layout";
import React, { useState } from "react";
import {
  Tabs,
  TabList,
  TabPanels,
  Tab,
  TabPanel,
  Button,
} from "@chakra-ui/react";
import General from "./tabContents/General";
import Content from "./tabContents/Content";
import Assessment from "./tabContents/Assessment";
import Announcement from "./tabContents/Announcement";
import Certificate from "./tabContents/Certificate";
import { useFormik } from "formik";

const CreatePrograms = ({ program }) => {
  const [formData, setFormData] = useState({
    title: program ? program.title : "",
    learn: "",
  });

  const handleFormDataChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  console.log(program);

  const formik = useFormik({
    initialValues: program
      ? {
          title: program.title,
          duration: program.duration,
          lessonFormat: program.lessonFormat,
          price: program.price,
          summary: program.summary,
          instructor: program.instructor,
          docFormat: program.docFormat,
          exam: program.exam,
          announcementTitle: program.announcementTitle,
          announcementDetails: program.announcementDetails,
          content: program.content,
        }
      : {
          title: "",
          duration: "",
          lessonFormat: "",
          price: "",
          summary: "",
          instructor: "",
          docFormat: "",
          exam: "",
          announcementTitle: "",
          announcementDetails: "",
          content: [
            {
              title: "",
              objective: "",
              file: {
                name: "",
                link: "",
              },
            },
          ],
        },

    onSubmit: (values) => {
      console.warn(values);
    },
  });

  // console.log(formData);
  return (
    <Box>
      <form onSubmit={formik.handleSubmit}>
        <Tabs>
          <TabList mr="5">
            <Tab p={5} w={1 / 5}>
              General
            </Tab>
            <Tab w={1 / 5}>Content</Tab>
            <Tab w={1 / 5}>Assessment</Tab>
            <Tab>Announcement</Tab>
            <Tab w={1 / 5}>Certificate</Tab>
            <Button my={3} type="submit">
              Save
            </Button>
          </TabList>

          <TabPanels px={6}>
            <TabPanel>
              <General formHandler={formik} />
            </TabPanel>

            <TabPanel>
              <Content formHandler={formik} />
            </TabPanel>
            <TabPanel>
              <Assessment formHandler={formik} />
            </TabPanel>
            <TabPanel>
              <Announcement
                formHandler={formik}
                onChangeEventHandler={handleFormDataChange}
              />
            </TabPanel>
            <TabPanel>
              <Certificate program={program} />
            </TabPanel>
          </TabPanels>
        </Tabs>
      </form>
    </Box>
  );
};

export default CreatePrograms;
